import React from "react"

const LeadStatusChip = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="inline-flex items-center px-2.5 py-0.5 rounded-full border border-divider text-xs font-semibold whitespace-nowrap text-text-secondary cursor-pointer transition-colors hover:text-primary-main hover:border-primary-main"
  >
    Set status
  </button>
)

export default LeadStatusChip
